import { Hierarchy } from './hierarchy'
import { TextAnalytics } from './textAnalytics'
import { QuestionsOverview } from './questionsOverview'
import { ExportDefinition } from './exportDefinition'
import { WysiwygEditor } from './wysiwygEditor'
import { DatamapImport } from './datamapImport'
import { ReportingColorSetting } from './settingsPage/reporting-color/reporting-color.component'
import { DatagridIconsEdit } from './datagridIconsEdit'
import { Form as FeedbackNotificationTemplatesForm } from './feedback/messenger/replyNotificationTemplates/form/form'
import { Form as FeedbackSettingsForm } from './feedback/messenger/settings/form/form'

export const Creator = (() => {
	const hierarchy = Hierarchy()
	const textAnalytics = TextAnalytics()
	const questionsOverview = QuestionsOverview()
	const exportDefinition = ExportDefinition()
	const wysiwygEditor = WysiwygEditor()
	const datamapImport = DatamapImport
	const datagridIconsEdit = DatagridIconsEdit()
	const init = (showModalOverview?: boolean, isAjax?: boolean) => {
		hierarchy.init()
		textAnalytics.init()
		questionsOverview.init()
		wysiwygEditor.init(isAjax)
		exportDefinition.init()
		datamapImport.init(showModalOverview)
		ReportingColorSetting.init()
		datagridIconsEdit.init()
		FeedbackNotificationTemplatesForm.init()
		FeedbackSettingsForm.init()
	}

	return {
		init,
	}
})()
